import React from "react";
import HelpModal from "common/HelpModal.jsx";

const NTPServersAdminHelpModal = () => (
  <HelpModal
    title="NTP Servers"
    content={() => (
      <>
        <p>
          List of NTP servers configured. Please verify that at least one NTP
          server is accessible in order to be able to validate licenses.
        </p>
        <ul>
          <li>
            <b>SERVER</b>: Status of the NTP server.
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              <li>
                <b>(*)</b> The server has been chosen for synchronization
              </li>
              <li>
                <b>(o)</b> The server has been chosen for synchronization, but
                the synchronization does not come from NTP.
              </li>
              <li>
                <b>(+)</b> The server is considered a possible candidate, but
                not chosen.
              </li>
              <li>
                <b>(#)</b> The server could be considered a possible candidate.
              </li>
              <li>
                <b>(r)</b> The server is discarded as unreachable, synchronized
                to this server (synch loop) or outrageous synchronization
                distance.
              </li>
              <li>
                <b>(x)</b> The server is discarded by the intersection algorithm
                as a falseticker.
              </li>
              <li>
                <b>(-)</b> The server is discarded by the clustering algorithm
                as an outlyer.
              </li>
            </ul>
          </li>
          <li>
            <b>SERVER</b>: NTP server IP address.
          </li>
          <li>
            <b>REFID</b>: clock synchronization source of NTP server.
          </li>
          <li>
            <b>STRATUM</b>: stratum level (accuracy) of the time source.
          </li>
          <li>
            <b>TYPE</b>: server type (L=local, U=Unicast, M=Multicast,
            B=Broadcast).
          </li>
          <li>
            <b>WHEN</b>: number of seconds passed since last response.
          </li>
          <li>
            <b>POLL</b>: polling interval, in seconds, of the source.
          </li>
          <li>
            <b>REACH</b>: indicates success/failure to reach server (377 = all
            attempts successful).
          </li>
          <li>
            <b>DELAY</b>: indicates the roundtrip time, in milliseconds, to
            receive a reply.
          </li>
          <li>
            <b>OFFSET</b>: indicates the time difference, in milliseconds,
            between the client and the server.
          </li>
          <li>
            <b>JITTER</b>: indicates the difference, in milliseconds, between
            two samples.
          </li>
          <li>
            <b>ACTIONS</b>: Allowed operations on the server.
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">delete</i> icon
          to delete an already configured NTP server.
        </p>
        <p>
          Press the <i className="material-icons valign-icon">more_vert</i> icon
          and then select the <b>Add Server...</b> option to add a new NTP
          server.
        </p>
        <p>
          Clock on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh the NTP server information.
        </p>
        <p>
          {" "}
          <b>NOTE:</b> When adding the first NTP server, when the time is
          synchronized, if the synchronization implies a significant change in
          time, it may cause a disruption in traffic of 10 seconds to 2 minutes,
          depending on the number of interfaces, CPU cores, and memory size. In
          those cases, it is recommended to perform a software reload of the
          active bqn package in Administration
          {"->"} Software
        </p>
      </>
    )}
  />
);

export default NTPServersAdminHelpModal;
